<!-- <p-button (click)="showModalDialog()" icon="pi pi-external-link" label="Show"></p-button> -->
<p-dialog header="AVISO" [(visible)]="displayModal" [modal]="true" [style]="{width: '50vw'}"
    [draggable]="false" [blockScroll]="true" [closeOnEscape]="false" [closable]="false" [resizable]="false">
    <p style="font-size: x-large; text-align: center;" class="p-m-0">Acerque su credencial al lector</p>
</p-dialog>